import { Unit, UnitPrefix, BaseUnits } from "uom";
import { CentiMeter, Inch, Foot } from "./length";
import { Cubed } from "../unit-cubed";
/** The metric unit for volume quantities ( <code>m³</code> ). */
export var CubicMeter = Cubed("CubicMeter", BaseUnits.Meter);
// Volume
export var CubicCentiMeter = Cubed("CubicCentiMeter", CentiMeter);
export var CubicInch = Cubed("CubicInch", Inch);
export var CubicFeet = Cubed("CubicFeet", Foot);
export var HundredCubicFeet = Unit.timesNumber("HundredCubicFeet", 100.0, CubicFeet);
export var Liter = Unit.divideNumber("Liter", 1000.0, CubicMeter);
export var MilliLiter = UnitPrefix.Milli("MilliLiter", Liter);
export var Gallon = Unit.timesNumber("Gallon", 3.785, Liter);
//# sourceMappingURL=volume.js.map